import { useCallback } from 'react';
import { Button, Icon, Text } from '@mercator-gcp/grout';
import { useNavigate } from 'react-router-dom';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { APP_ROUTES } from 'utils/navigation';

const containerStyle = {
  height: '100%',
  width: '100%',
  marginTop: '240px',
  alignItems: 'center',
};

const titleStyle = {
  marginBottom: 'padding_16',
  justifyContent: 'center',
};

const descriptionStyle = {
  marginBottom: 'padding_24',
  justifyContent: 'center',
};

const EmptyGroupPlaceholder = () => {
  const navigate = useNavigate();

  const onCLickCTA = useCallback(() => {
    navigate(APP_ROUTES.COMPANY_SEARCH_PAGE);
  }, []);

  return (
    <FlexColumn sx={containerStyle}>
      <Text.H2 sx={titleStyle}>Get started with Mercator.ai</Text.H2>
      <Text sx={descriptionStyle}>
        Get ready for your next meeting by tracking your clients.
      </Text>
      <Button
        variant="primary"
        onClick={onCLickCTA}
        startAdornment={<Icon name={Icon.Name.Search} />}
      >
        Search a company
      </Button>
    </FlexColumn>
  );
};

export default EmptyGroupPlaceholder;
